import type { ClientEntry, Sector } from '../types/content'

export const clientRegister: ClientEntry[] = [
  { name: 'Rukuriri Tea Factory Co. Ltd', location: 'Runyenjes' },
  { name: 'Mogogosiek Tea Factory Co. Ltd', location: 'Kericho' },
  { name: 'Kapsara Tea Factory Co. Ltd', location: 'Kitale' },
  { name: 'Boito Tea Factory Co. Ltd', location: 'Litein' },
  { name: 'Chebut Tea Factory Co. Ltd', location: 'Kapsabet' },
  { name: 'Motigo Tea Factory Co. Ltd', location: 'Nairobi' },
  { name: 'Kapset Tea Factory Co. Ltd', location: 'Kericho' },
  { name: 'Tegat Tea Factory Co. Ltd', location: 'Kericho' },
  { name: 'Kapkoros Tea Factory PLC', location: 'Litein' },
  { name: 'Olenguruone Tea Factory Ltd', location: 'Molo' },
  { name: 'Momul Tea Factory Co. Ltd', location: 'Nairobi' },
  { name: 'Tirgaga Tea Factory', location: 'Litein' },
  { name: 'Githongo Tea Factory Co. Ltd', location: 'Meru' },
  { name: 'Weru Tea Factory Co. Ltd', location: 'Chogoria' },
  { name: 'Mudete Tea Factory Co. Ltd', location: 'Maragoli' },
  { name: 'Kobel Tea Factory Co. Ltd', location: 'Kericho' },
  { name: 'Toror Tea Factory Co. Ltd', location: 'Kericho' },
  { name: 'Kaptumo Tea Factory Co. Ltd', location: 'Kapset' },
  { name: 'Ngeere Tea Factory Co. Ltd', location: 'Thika' },
  { name: 'Premier Corner Stone', location: 'Meru' },
  { name: 'New Sarvid Place Limited', location: 'Ruaraka' },
  { name: 'Gituma & Co. Advocates Ltd', location: 'Meru' },
  { name: 'Mutuma & Koskei Advocates', location: 'Meru' },
  { name: 'M.D Maranya & Co. Advocates', location: 'Meru' },
]

export const sectors: Sector[] = [
  {
    index: '01',
    name: 'Tea & Agribusiness',
    description:
      'Statutory audit, tax and management accounting for tea factory companies across Kericho, Litein, Meru, Nandi and the Rift.',
  },
  {
    index: '02',
    name: 'Legal Practices',
    description:
      'Client account reconciliation, bookkeeping and tax compliance for advocates and law firms.',
  },
  {
    index: '03',
    name: 'Corporates & SMEs',
    description:
      'Reporting accountants, payroll bureau and finance advisory for growing companies and family businesses.',
  },
  {
    index: '04',
    name: 'Government & NGOs',
    description:
      'Project audit, donor reporting and monitoring, evaluation & learning for public and faith-based programmes.',
  },
]
